<template>
  <div class="mainbox" @click="showState">
    <section class="app-main">
      <transition name="fade-transform" mode="out-in">
        <!-- <keep-alive> -->
        <router-view :key="key" />
        <!-- </keep-alive> -->
      </transition>
    </section>
  </div>
</template>

<script>
export default {
  computed: {
    key() {
      return;
      if (this.$route.fullPath); //完成解析后的 URL，包含查询参数和 hash 的完整路径
    }
  },
  methods: {
    showState() {
      this.$store.state.show = false;
    }
  }
};
</script>

<style lang='scss' scoped>
.mainbox {
  width: calc(100% - 240px);
  min-height: calc(100% - 100px);
  background: #f0f2f5;
  position: absolute;
  left: 200px;
  top: 60px;
  font-size: 20px;
  padding: 20px;
  .app-main {
    width: calc(100% - 40px);
    min-height: 650px;
    background: #fefefe;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
    padding: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/layout/components/appmain.vue